import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { NavOverflowItem } from '@vg-constellation/angular-20/nav-overflow';
import { NgIf } from '@angular/common';
import { ChipModule } from '@vg-constellation/angular-20/chip';

import { NavOverflowExtendedData } from '../../../interfaces/nav-overflow-extended-data.interface';
import { UsersService } from '../../../services/users/users.service';
import { ContentUtil } from '../../../utils/content/content.util';
import { isInternalEnvironment } from '../../../../common/utils/common.util';
import { TileComponent } from '../tile.component';
import { MapAccountTypePipe } from '../../../pipes/map-account-type/map-account-type.pipe';
import { MapRoleTypePipe } from '../../../pipes/role-type/map-role-type.pipe';

export interface UserTileInputDataProps {
    accId?: string;
    accName?: string;
    accType?: string;
    roleType: string;
    usrName: string;
    accessLevel?: string;
    isHsgRecipient?: boolean;
    poid: string;
}

@Component({
    selector: 'zci-user-tile',
    templateUrl: './user-tile.component.html',
    imports: [
        NgIf,
        TileComponent,
        ChipModule,
        MapAccountTypePipe,
        MapRoleTypePipe,
    ],
})
export class UserTileComponent implements OnChanges, UserTileInputDataProps {
    private readonly usersService = inject(UsersService);

    content = ContentUtil.content;

    navOverflowMenuConfig: NavOverflowExtendedData;

    isInternal = isInternalEnvironment();

    @Input() accName?: string;

    @Input() accType?: string;

    @Input() roleType: string;

    @Input() usrName: string;

    @Input() hasSelectedAccount: boolean = false;

    @Input() isHsgRecipient: boolean = false;

    @Input() poid: string;

    @Output() selectAction: EventEmitter<NavOverflowItem> = new EventEmitter();

    ngOnChanges() {
        this.navOverflowMenuConfig = this.usersService.getNavOverflowMenu(this.hasSelectedAccount);
    }
}
